import React,{useState,useEffect} from 'react';
import '../styles/SkillsPattern.css'
const SecondPattern = ({trigger})=>{
    const [isTriggered,setIsTrigerred] = useState(false)
    const FirstStageClass = isTriggered ? 'second-pattern' : 'initial'
    
    
    useEffect(()=>{
        if(trigger){
           setIsTrigerred(true)
         
        }
       })
    return(
        <svg className={FirstStageClass}  width="113" height="453" viewBox="0 0 113 453" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect  x="7.0715" y="0.707107" width="9" height="9" transform="rotate(45.0039 7.0715 0.707107)" stroke="#0066FF"/>
<rect  x="105.072" y="0.707107" width="9" height="9" transform="rotate(45.0039 105.072 0.707107)" stroke="#0066FF"/>

<path  d="M105 13V78.0978L77 119" stroke="#0066FF"/>
<path  d="M7 13V78.0978L36 119" stroke="#0066FF"/>

<rect   x="57.0715" y="50.7071" width="9" height="9" transform="rotate(45.0039 57.0715 50.7071)" stroke="#0066FF"/>

<path id='third-part' d="M57 63L56 438.998" stroke="#0066FF"/>

<path  d="M36 38L35.3519 398.5L11.0463 431"  stroke="#0066FF"/>
<path  d="M77 39L77.6493 398.5L102 431" stroke="#0066FF"/>

<circle  cx="105" cy="435" r="4.5"  stroke="#0066FF"/>
<rect x="56.0715" y="438.707"  width="9" height="9" transform="rotate(45.0039 56.0715 438.707)" stroke="#0066FF"/>
<circle   cx="9" cy="435" r="4.5"  stroke="#0066FF"/>

</svg>
    )
}
export default SecondPattern;